export function deleteKeyFormData (formData, keyStringArray) {
  const prepareFormData = { ...formData }

  for (const key of keyStringArray) {
    delete prepareFormData[key]
  }

  return prepareFormData
}
